import { Component, ViewChild, AfterViewInit, Input, SimpleChanges, OnInit } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Router } from '@angular/router';
import { AssignedCustomer } from 'src/app/models';
import { GridBase } from 'src/app/services/tables/GridBase';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { Subscription } from 'rxjs';


export interface CustomerList {
  priceTemplateName: string;
  customerName: string;
  customerInfoByGroupId: number;
}

@Component({
  selector: 'customer-assigned',
  templateUrl: './customers-assigned.component.html',
  styleUrls: ['./customers-assigned.component.scss']
})

export class CustomersAssignedComponent extends GridBase implements OnInit {
  @Input() customers: AssignedCustomer[] = [];

  displayedColumns: string[] = ['Company Name'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  sortChangeSubscription: Subscription;
  public resultsLength = 0;
  public customerDataSource: MatTableDataSource<any> = null;

  constructor(private router: Router) {
    super();
  }

    ngOnInit(): void {
        if (!this.customers) {
            return;
        }

        console.log('CustomersAssignedComponent ngOnInit', this.customers);

        this.customerDataSource = new MatTableDataSource(this.customers);
        this.customerDataSource.sort = this.sort;
        this.customerDataSource.paginator = this.paginator;

        this.setVirtualScrollVariables(this.paginator, this.sort, this.customerDataSource.data);
    }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customers'] && this.customers) {
        this.dataSource.data = changes.customers;
    }
  }

  onRowClicked(row: AssignedCustomer): void {
    this.router.navigate(['/default-layout/customers', row.customerInfoByGroupId]);
  }
}